export function getErrorMessage(e) {
  const { response: { data: { message } = {} } = {} } = e;
  return message || e.message || 'Unspecified error';
}



// WEBPACK FOOTER //
// ./src/utils/error.js